/*
 * @Author: 黄悦凯 huangyuekai@jafron.com
 * @Date: 2025-12-02 11:20:59
 * @LastEditors: 黄悦凯 huangyuekai@jafron.com
 * @LastEditTime: 2025-12-12 11:20:29
 * @FilePath: \carpooling-vue\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Router.prototype.openPage = function (link, query) {
  this.push({
    path: link,
    query: Object.assign({
      time: new Date().getTime()
    }, query || {})
  })
};
Vue.use(Router)



export default new Router({
  mode: 'history',
  routes: [
    //导航重定向
    // {
    //   path: '/',
    //   redirect: '/index',
    //   meta: {
    //     title: '健帆拼车'
    //   }
    // },
    {
      path: '/',
      name: 'blackLayout',
      component: Layout,
      redirect: '/index',
      children: [
        {
          path: 'index',
          name: 'blackIndex',
          component: () => import('@/views/index/index.vue'),
          meta: {
            title: '晚班拼车',
            TabbarShow: true,
            auth: true // 如果此路由需要微信授权请设置为true,默认为false
          }
        },
        {
          path: 'login',
          name: 'blakLogin',
          component: () => import('@/views/index/login.vue'),
          meta: {
            title: '注册认证',
            auth: true
          }
        },
        {
          path: 'detail',
          name: 'blackDetail',
          component: () => import('@/views/index/detail.vue'),
          meta: {
            title: '晚班拼车',
            auth: true
          }
        },
        {
          path: 'error',
          name: 'blackError',
          component: () => import('@/views/index/error.vue'),
          meta: {
            title: '错误'
          }
        },
      ]
    },
    {
      path: '/home',
      name: 'Home',
      component: Layout,
      redirect: 'home/index',
      children: [
        {
          path: 'index',
          name: 'HomeIndex',
          component: () => import('@/views/home/index.vue'),
          meta: {
            title: '我的设置',
            TabbarShow: true,
            auth: true
          }
        },
        {
          path: 'routeSet',
          name: 'HomeRouteSet',
          component: () => import('@/views/home/routeSet.vue'),
          meta: {
            title: '编辑',
            auth: true
          }
        },
        {
          path: 'record',
          name: 'HomeRecord',
          component: () => import('@/views/home/record.vue'),
          meta: {
            title: '拼车记录',
            auth: true
          }
        },
        {
          path: 'feedback',
          name: 'HomeFeedback',
          component: () => import('@/views/home/feedback.vue'),
          meta: {
            title: '反馈',
            auth: true
          }
        },
        {
          path: 'subscribe',
          name: 'HomeSubscribe',
          component: () => import('@/views/home/subscribe.vue'),
          meta: {
            title: '取消订阅通知',
            auth: true
          }
        },
        {
          path: 'abnormal',
          name: 'HomeAbnormal',
          component: () => import('@/views/home/abnormal.vue'),
          meta: {
            title: '异常提交',
            auth: true
          }
        },
        {
          path: 'guide',
          name: 'HomeGuide',
          component: () => import('@/views/home/guide.vue'),
          meta: {
            title: '用户指南'
          }
        },
        {
          path: 'report',
          name: 'HomeReport',
          component: () => import('@/views/home/report.vue'),
          meta: {
            title: '数据报表',
            auth: true
          }
        },
        {
          path: 'account',
          name: 'HomeAccount',
          component: () => import('@/views/home/account.vue'),
          meta: {
            title: '月度核算',
            auth: true
          }
        }
      ]
    },
    {
      path: '/work',
      name: 'workLayout',
      component: Layout,
      redirect: '/work/index',
      children: [
        {
          path: 'index',
          name: 'workIndex',
          component: () => import('@/views/work/index.vue'),
          meta: {
            title: '早班拼车',
            TabbarShow: true,
            auth: true
          }
        },
        {
          path: 'login',
          name: 'workLogin',
          component: () => import('@/views/work/login.vue'),
          meta: {
            title: '早班拼车',
            auth: true
          }
        },
        {
          path: 'apply',
          name: 'workApply',
          component: () => import('@/views/work/apply.vue'),
          meta: {
            title: '拼车申请',
            auth: true
          }
        },
        {
          path: 'bind',
          name: 'workBind',
          component: () => import('@/views/work/bind.vue'),
          meta: {
            title: '详情',
            auth: true
          }
        },
        {
          path: 'audit',
          name: 'workAudit',
          component: () => import('@/views/work/audit.vue'),
          meta: {
            title: '绑定申请',
            auth: true
          }
        },
        {
          path: 'passenger',
          name: 'workPassenger',
          component: () => import('@/views/work/passenger.vue'),
          meta: {
            title: '拼车申请',
            TabbarShow: true,
            auth: true
          }
        },
        {
          path: 'detail',
          name: 'workDetail',
          component: () => import('@/views/work/detail.vue'),
          meta: {
            title: '拼车详情',
            auth: true
          }
        }
      ]
    },
    {
      path: '/im',
      name: 'IMWeb',
      component: Layout,
      redirect: 'im/index',
      children: [
        {
          path: 'index',
          name: 'appraiseIndex',
          component: () => import('@/views/im/index.vue'),
          meta: {
            title: '客服日常管理',
            auth: false
          }
        },
        {
          path: 'qw',
          name: 'qwIndex',
          component: () => import('@/views/im/qw.vue'),
          meta: {
            title: '企微',
            auth: true
          }
        },
      ]
    },
    {
      path: '/QRcode',
      name: 'QR',
      component: Layout,
      redirect: 'QRcode/index',
      children: [
        {
          path: 'index',
          name: 'QR',
          component: () => import('@/views/QRcode/index.vue'),
          meta: {
            title: '通勤扫码',
            auth: true
          }
        },
        {
          path: 'success',
          name: 'Success',
          component: () => import('@/views/QRcode/success.vue'),
          meta: {
            title: '扫码成功',
            auth: false
          }
        },
        {
          path: 'error',
          name: 'Error',
          component: () => import('@/views/QRcode/error.vue'),
          meta: {
            title: '扫码失败',
            auth: false
          }
        }
      ]
    },
    {
      path: '/appraise',
      name: 'Appraise',
      component: Layout,
      redirect: 'appraise/index',
      children: [
        {
          path: 'index',
          name: 'appraiseIndex',
          component: () => import('@/views/appraise/index.vue'),
          meta: {
            title: '评价',
            auth: true
          }
        },
        {
          path: 'list',
          name: 'appraiseList',
          component: () => import('@/views/appraise/list.vue'),
          meta: {
            title: '评价列表',
            auth: true
          }
        },
        {
          path: 'echart',
          name: 'appraiseEchart',
          component: () => import('@/views/appraise/echart.vue'),
          meta: {
            title: '雷达图'
          }
        },
      ]
    },
    {
      path: '/transport',
      name: 'Transport',
      component: Layout,
      redirect: 'transport/index',
      children: [
        {
          path: 'index',
          name: 'transportIndex',
          component: () => import('@/views/transport/index.vue'),
          meta: {
            title: '装货用车',
            auth: true
          }
        },
        {
          path: 'detail',
          name: 'transportDetail',
          component: () => import('@/views/transport/detail.vue'),
          meta: {
            title: '订单详情',
            auth: true
          }
        },
        {
          path: 'list',
          name: 'transportList',
          component: () => import('@/views/transport/list.vue'),
          meta: {
            title: '订单列表'
          }
        },
        {
          path: 'driver',
          name: 'transportDriver',
          component: () => import('@/views/transport/driver.vue'),
          meta: {
            title: '转货订单中心'
          }
        },
        {
          path: 'guide',
          name: 'transportGuide',
          component: () => import('@/views/transport/guide.vue'),
          meta: {
            title: '转货操作手册'
          }
        }
      ]
    },
    {
      path: '/anniversary',
      name: 'Anniversary',
      component: Layout,
      redirect: 'anniversary/index',
      children: [
        {
          path: 'index',
          name: 'anniversaryIndex',
          component: () => import('@/views/anniversary/index.vue'),
          meta: {
            title: '春茗晚宴',
            auth: false
          }
        },
        {
          path: 'error',
          name: 'anniversaryError',
          component: () => import('@/views/anniversary/error.vue'),
          meta: {
            title: '错误'
          }
        }
      ]
    },
    {
      path: "/clockIn",
      name: "clockIn",
      component: Layout,
      redirect: 'clockIn/index',
      children: [
        {
          path: 'index',
          name: 'clockInIndex',
          component: () => import('@/views/clockIn/index.vue'),
          meta: {
            title: '人人都是品牌官',
            auth: true
          }
        },
        {
          path: 'checkIn',
          name: 'checkInIndex',
          component: () => import('@/views/clockIn/checkIn/index.vue'),
          meta: {
            title: '日常打卡',
            auth: true
          }
        },
        {
          path: 'checkInDetail',
          name: 'checkInDetail',
          component: () => import('@/views/clockIn/checkIn/detail.vue'),
          meta: {
            title: '打卡详情',
            auth: true
          }
        },
        {
          path: 'material',
          name: 'materialIndex',
          component: () => import('@/views/clockIn/material/index.vue'),
          meta: {
            title: '素材管理',
            auth: true
          }
        },
        {
          path: 'materialDetail',
          name: 'materialDetail',
          component: () => import('@/views/clockIn/material/detail.vue'),
          meta: {
            title: '素材详情',
            auth: true
          }
        },
        {
          path: 'admin',
          name: 'adminIndex',
          component: () => import('@/views/clockIn/admin/index.vue'),
          meta: {
            title: '后台管理',
            auth: true
          }
        },
      ]
    },
  ]
})
